module.exports = __webpack_public_path__ + "img/noQuestions.a7acb1c0.svg";